import { useState } from "react";
import { useTranslation } from "react-i18next";

import intro from "../../assets/images/magicPen/intro.gif";
import SlideInAnimation from "../../components/animation/SlideInAnimation";
import GameTitle from "../../components/game/GameTitle";
import Text from "../../components/ui/Text";
import useStore from "../../hooks/store/useStore";

import PenPicker from "./components/PenPicker";
import TryItCard from "./components/TryItCard";

export default function MagicPenHome() {
  const { t } = useTranslation();
  const { userInformation } = useStore((state) => state.user);
  const { market } = userInformation || {};
  const [showPens, setShowPens] = useState(false);

  return (
    <div className="flex w-full flex-1 flex-col">
      <div className="mx-auto flex w-full max-w-[480px] flex-col">
        <GameTitle text="Magic Pen" />

        <div className="mt-2 px-6 pb-4">
          <Text normal>{t("magicPenDesc")}</Text>
        </div>

        {market === "JP" ? null : (
          <div className="relative w-full">
            <img
              src={intro}
              alt="intro"
              className="h-[390px] w-full object-cover tablet:h-[480px]"
            />

            <div className="absolute inset-0 flex flex-col justify-between px-6 py-4">
              <Text
                className="text-2xl text-white"
                style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)" }}
              >
                {t("magicPenVideoTitle")}
              </Text>
            </div>
          </div>
        )}
      </div>

      {market === "JP" ? (
        <div className="flex flex-1 flex-col items-center justify-center gap-6 bg-gradient-to-b from-pink2 to-pink1">
          <PenPicker />
        </div>
      ) : (
        <>
          <div className="flex justify-center bg-gradient-to-b from-[#FDE0C8] to-pink1 py-4 tablet:py-[60px]">
            <TryItCard onClick={() => setShowPens(true)} />
          </div>

          <SlideInAnimation
            isVisible={showPens}
            className="fixed inset-x-0 bottom-0 mx-auto flex h-[486px] w-full max-w-[834px] flex-col items-center gap-6 rounded-t-3xl bg-gradient-to-t from-pink2 to-pink1 pt-3"
          >
            <PenPicker onClose={() => setShowPens(false)} />
          </SlideInAnimation>
        </>
      )}
    </div>
  );
}
